export default __webpack_public_path__ + "static/easyIcon2-4302900ccdb2e514bab16f4b1ecd08d5.png";